import { render, staticRenderFns } from "./CertificatePage.vue?vue&type=template&id=22bb9ea0&scoped=true&"
import script from "./CertificatePage.vue?vue&type=script&lang=js&"
export * from "./CertificatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bb9ea0",
  null
  
)

export default component.exports